<nav [ngClass]="{'open': !(menuCollapsed | async)}" [@slideMobileNav]="!(windowService.isXsOrSm() | async) ? 'default' : ((menuCollapsed | async) ? 'collapsed' : 'expanded')"
  class="navbar navbar-light p-0 navbar-container" role="navigation" [attr.aria-label]="'nav.main.description' | translate">
  <div class=" w-100 h-100" [class.container]="!(isXsOrSm$ | async)" style="margin-top: 30px;">
    <div class="row w-100 ">
      <div class="w-100 col-2">
        <a class="navbar-brand my-2 w-100 h-100" routerLink="/home">
          <div>
            <svg viewBox="0 0 70 17" fill="none" xmlns="http://www.w3.org/2000/svg" style="height:25px;">
              <path d="M14.1129 15.1596C13.0585 15.5495 11.8473 16.1001 10.593 16.2834C6.8922 16.8235 0 14.9626 0 8.01008C0 1.05755 6.76859 -0.523157 10.778 0.13722C12.0107 0.339854 13.1332 0.838769 14.0955 1.19883L14.0806 5.06421C14.0806 5.06421 12.4239 3.88958 10.0828 3.50369C7.74169 3.1186 3.78789 4.04216 3.78789 8.10211C3.78789 12.1629 7.81386 13.2495 9.97493 12.9338C12.136 12.6182 14.0806 11.4258 14.0806 11.4258L14.1129 15.1596Z" fill="#231F20"></path>
              <path d="M25.4028 12.9055C22.7062 12.9055 20.5199 10.7922 20.5199 8.18549C20.5199 5.578 22.7062 3.46466 25.4028 3.46466C28.1002 3.46466 30.2865 5.578 30.2865 8.18549C30.2865 10.7922 28.1002 12.9055 25.4028 12.9055ZM25.4028 1.12502e-08C20.726 1.12502e-08 16.9355 3.66456 16.9355 8.18549C16.9355 12.7064 20.726 16.371 25.4028 16.371C30.0796 16.371 33.871 12.7064 33.871 8.18549C33.871 3.66456 30.0796 1.12502e-08 25.4028 1.12502e-08Z" fill="#231F20"></path>
              <path d="M40.8166 10.2314L42.6045 4.55958L44.5513 10.2314H40.8166ZM44.6115 0.0184681H40.7468L34.4355 16.5323H38.7447L39.7598 13.5439H45.5985L46.6128 16.5323H50.922L44.6115 0.0184681Z" fill="#231F20"></path>
              <path d="M66.2461 1.12502e-08L61.5323 6.26479L56.8185 1.12502e-08H53.0645V16.5884H56.9862V6.35707L61.5323 12.1308L66.0783 6.35707V16.5884H70V1.12502e-08H66.2461Z" fill="#231F20"></path>
              </svg>
            </div>
            <div>
              <img src="assets/images/logo-fundacion-nara-negro.svg" alt="'Fundación COAM"  style="height:45px;"/>
            </div>
            
        </a>
      </div>
      <div class="w-100 col-8" style="text-align: center;padding-top: 15px;">
        <h1 class="display-5" style="font-size: 2.5rem; font-weight:bolder;">BIBLIOTECA DIGITAL JUAN DE VILLANUEVA</h1>
      </div>
      <div class="w-100 col-2" style="text-align: right; padding-top: 26px;">
        <div class="navbar-buttons d-flex align-items-right gapx-1">
          <ds-themed-search-navbar class="navbar-collapsed"></ds-themed-search-navbar>
          <ds-themed-lang-switch class="navbar-collapsed"></ds-themed-lang-switch>
          <ds-context-help-toggle class="navbar-collapsed"></ds-context-help-toggle>
          <ds-themed-auth-nav-menu class="navbar-collapsed"></ds-themed-auth-nav-menu>
          <ds-impersonate-navbar class="navbar-collapsed"></ds-impersonate-navbar>
        </div>
      </div>
    </div>
    <div class="row w-100 ">
      <div class="col-12">
        <div id="collapsingNav" class="w-100 h-100">
          <ul class="navbar-collapse mr-auto w-100" style="display:flex; flex-direction:row-reverse; list-style: none; text-transform: uppercase;">
            <li *ngIf="(isXsOrSm$ | async) && (isAuthenticated$ | async)" style="margin: 15px; color: #343a40;">
                <ds-user-menu [inExpandableNavbar]="true"  class="navbar-collapsed "></ds-user-menu>
            </li>
            <li *ngFor="let section of (sections | async)"  style="margin-left: 20px;">
              <ng-container *ngComponentOutlet="(sectionMap$ | async).get(section.id)?.component; injector: (sectionMap$ | async).get(section.id)?.injector;"></ng-container>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>
